var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rice-preview_render",
      style: { width: _vm.currentRenderWidth }
    },
    [
      _c("skeleton", { attrs: { loading: _vm.renderLoading, row: 10 } }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.renderLoading,
              expression: "!renderLoading"
            }
          ]
        },
        [
          _vm.itemManage === "group"
            ? _vm._l(_vm.domainNodeList, function(item) {
                return _c("render-item-template", {
                  key: item.id,
                  attrs: { formNode: item },
                  on: { "hook:mounted": _vm.renderMounted }
                })
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.formList, function(item) {
            return _c("render-item-template", {
              key: item.id,
              attrs: { formNode: item },
              on: { "hook:mounted": _vm.renderMounted }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e1fad7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e1fad7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/RicePreviewRender/src/RicePreviewRender.vue
// module id = null
// module chunks = 